module.exports = "https://static.energy5.com/_next/static/images/glance-3-4aac3f28a9838dfb901cb40566077aec.png";